import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import * as moment from 'moment';


interface Frame {
  id: number,
  name: string,
  is_published?: number
}

@Component({
  selector: 'vr-delete-modal',
  templateUrl: './export-audit-dialog.component.html',
  styleUrls: ['./export-audit-dialog.component.scss']
})
export class ExportAuditDialogComponent implements OnInit {
  frames: Frame[];
  framesPrincipal: Frame[];
  trameEnfant: Frame[];
  selectedFrame : number ;
  detailsMode: boolean = false;
  exportFormat: string = 'csv';
  selectedFrameParent : number;
  selectedtrameEnfant = [];
  startDate: any;
  endDate: any;
  filteredFrames: Frame[] = [];
  searchQuery: string = '';
  filteredFramesPrincipal: Frame[] = [];
  searchQueryDetaille: string = '';

  enterprises: any[] = [];
  filteredEnterprises: any[] = [];
  selectedEnterprise: number;
  searchQueryEnterprise: string = '';
  startDateAll: any;
  endDateAll: any;
  startDateEnterprise: any;
  endDateEnterprise: any;

  constructor(@Inject(MAT_DIALOG_DATA) public defaults: any,
              private dialogRef: MatDialogRef<ExportAuditDialogComponent>,
              private http: HttpClient
  ) {}

  ngOnInit() {
    this.http.get(environment.API_PATH + 'frame', {withCredentials: true}).subscribe((response) => {
      if (response['success']) {
        this.frames = response['frames'];
        this.frames.unshift({ id: 0, name: 'AUDIT PHOTO' })
        // Tri par nom (A-Z)
        this.frames.sort((a, b) => a.name.localeCompare(b.name))
        this.filteredFrames = [...this.frames ];

      }
    });

    // on recup toutes les trames principales
    this.http.get(environment.API_PATH + 'frame/trame', {withCredentials: true}).subscribe((response) => {
      if (response['success']) {
        this.framesPrincipal = response['frames'];
        this.framesPrincipal.unshift({ id: 0, name: 'AUDIT PHOTO' })
        // Tri par nom (A-Z)
        this.framesPrincipal.sort((a, b) => a.name.localeCompare(b.name));
        this.filteredFramesPrincipal = [...this.framesPrincipal];

      }
    });
    this.http.get(environment.API_PATH + 'enterprise?lite=1&type=all', {withCredentials: true}).subscribe((response) => {
      if (response['success']) {
        this.enterprises = response['enterprises'] || [];
        this.enterprises.sort((a, b) => a.name.localeCompare(b.name));
        this.filteredEnterprises = [...this.enterprises];
      }
    });

    let date = new Date();
    let firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    const start = moment(firstDay).format('YYYY-MM-DD');
    const end = moment(date).format('YYYY-MM-DD');
    this.startDate = start;
    this.endDate = end;
    this.startDateAll = start;
    this.endDateAll = end;
    this.startDateEnterprise = start;
    this.endDateEnterprise = end;
  }

  cancel() {
    this.dialogRef.close();
  }

  /**
   * 
   */
  onSearch() {
    if (!this.frames) return;
    if (!this.searchQuery) {
      this.filteredFrames = [...this.frames];
      return;
    }
    this.filteredFrames = this.frames.filter(frame =>
      frame.name.toLowerCase().includes(this.searchQuery.toLowerCase())
    );
    this.filteredFrames.sort((a, b) => a.name.localeCompare(b.name));
  }

  onSearchDetaille() {
    if (!this.searchQueryDetaille) {
      this.filteredFramesPrincipal = [...this.framesPrincipal];
      return;
    }
    this.filteredFramesPrincipal = this.framesPrincipal.filter(frame =>
      frame.name.toLowerCase().includes(this.searchQueryDetaille.toLowerCase())
    );
    this.filteredFramesPrincipal.sort((a, b) => a.name.localeCompare(b.name));
  }

  onDetailsChange() {
    if (!this.detailsMode && this.exportFormat === 'pdf') {
      this.exportFormat = 'csv';
    }
  }

  validExport() {
    const formats = { csv: this.exportFormat === 'csv', pdf: this.exportFormat === 'pdf' };
    if (this.detailsMode) {
      this.dialogRef.close([{ id: this.selectedFrame, start: this.startDate, end: this.endDate, formats }]);
      return;
    }
    this.dialogRef.close({ id: this.selectedFrame, start: this.startDate, end: this.endDate, formats });
  }

  validExportDetaille() {
    let data = [];

    this.selectedtrameEnfant.forEach(id => {
      
      let enfant = {
        id: id,
        start: this.startDate,
        end: this.endDate,
      } ;

      data.push(enfant);
    });
    
    this.dialogRef.close(data);
  }

  onSearchEnterprise() {
    if (!this.searchQueryEnterprise) {
      this.filteredEnterprises = [...this.enterprises];
      return;
    }
    this.filteredEnterprises = this.enterprises.filter(e =>
      e.name.toLowerCase().includes(this.searchQueryEnterprise.toLowerCase())
    );
  }

  validExportAll() {
    this.dialogRef.close({ exportAll: true, start: this.startDateAll, end: this.endDateAll });
  }

  validExportByEnterprise() {
    this.dialogRef.close({ exportByEnterprise: true, audited_id: this.selectedEnterprise, start: this.startDateEnterprise, end: this.endDateEnterprise });
  }

  findTrameEnfant() {
    this.selectedtrameEnfant = [];
    this.selectedtrameEnfant.push(Number(this.selectedFrameParent));

    this.http.get(environment.API_PATH + `frame/enfant/${this.selectedFrameParent}`, {withCredentials: true}).subscribe((response) => {
      if (response['success']) {
        this.trameEnfant = response['frames'];
      }
    });
  }

  selectEnfant(id) {

    if (this.selectedtrameEnfant.includes(id)) {

      let index = this.selectedtrameEnfant.indexOf(id);
      this.selectedtrameEnfant.splice(index,1);

    } else {
      this.selectedtrameEnfant.push(id);
      
    }
  }
}



// WEBPACK FOOTER //
// /home/web_clients/qualicheck.fr/preprod/erp/src/app/core/dialogs/export-audit-dialog/export-audit-dialog.component.ts